import React, { Component } from 'react';
import Link from 'gatsby-link';
import { Route, Switch, withRouter } from 'react-router-dom';

import logoFooter from '../../img/logo-footer.png';
import iconFooterFacebook from '../../img/icon-footer-facebook.png';
import iconFooterInstagram from '../../img/icon-footer-instagram.png';
import iconFooterYoutube from '../../img/icon-footer-youtube.png';
import MDReactComponent from 'markdown-react-js';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import BicenturyLink from "../link";

class Footer extends Component {
	constructor(props) {
		super(props);
		this.lang = props.lang;
		this.data = props.data;
		this.translations = props.translations;
		this.activeCookiesLayer = props.onClickActiveCookiesControl;

		//console.log('data info', this.data);

		this.contact = this.data.footerPages.map(x => x).filter(x => x.type === 'contact')[0];
		this.company = this.data.footerPages.map(x => x).filter(x => x.type === 'company')[0];
		this.legal = this.data.footerPages.map(x => x).filter(x => x.type === 'legal')[0];
		this.privacity = this.data.footerPages.map(x => x).filter(x => x.type === 'privacity')[0];
		this.politica = this.data.footerPages.map(x => x).filter(x => x.type === 'politics')[0];
	}
	render() {
		const productList = (child, idx) => {
			return (
				<li key={idx}>
					<Link to={`/${child.lang}${child.path}`} title="">{child.title}</Link>
				</li>
			)
		}
		var location = '';
		if ("undefined" != typeof(window)) {
			location = window.location.pathname;
		}
		var splittedValue = location.split('/');
		let path_1 = '/', path_2 = '';
		for (let i = 2; i < splittedValue.length;i++) {
			path_2 += splittedValue[i];
			if (i < splittedValue.length -1) {
				path_2 += '/';
			}
		}
		if (path_2 === '/') {
			path_2 = '';
		}
		if (path_2.length > 0) {
			path_2 = '/'+path_2;
		}

		const footerItems = (item, idx) => {
			if(item.linktype=='cookie') {
				return (<li key={idx} className="fakeLink"><span onClick={this.activeCookiesLayer}>{item.text}</span></li>);
			}else{
				return (<li key={idx}><BicenturyLink link={`/${item.link}`} lang={this.lang} text={item.text} type={item.linktype}/></li>);
			}			
		}

		return (
			<footer>
				<section className="pre-footer">
					<div className="container">
						<div className="row">
							<div className="small-12">
								<h2 className="white unicSize">{this.translations.attitude_title}</h2>
								<div className="content-text">
									<MDReactComponent text={this.translations.attitude_text} />
								</div>
								<ul className="tags">
									<li>
										<p>{this.translations.attitude_hashtags}</p>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</section>
				<section className="post-footer">
					<div className="container">
						<div className="row logo-container">
							<div className="small-12"><img src={logoFooter} alt="" /></div>
						</div>
						<ul className="row principal-list">
							<li className="small-4 medium-3">
								<p>{this.translations.menu}</p>
								<ul>
									{this.data.products.map(productList)}
								</ul>
							</li>
							<li className="small-4 medium-3">
								<p>{this.translations.languages}</p>
								<ul data-is-languages-list>
									<li><a href={`${path_1}es${path_2}`} title="Castellano" data-lang="es">Castellano</a></li>
									<li><a href={`${path_1}pt${path_2}`} title="Português" data-lang="pt">Português</a></li>
								</ul>
							</li>
							<li className="small-4 medium-3">
								<p>Bicentury</p>
								<ul>
									{
										this.data.navbarItems.bottom.map(footerItems)
									}
								</ul>
							</li>
							<li className="small-12 medium-3">
								<p>{this.translations.followus}</p>
								<ul className="social">
									<li>
										<OutboundLink href="https://www.facebook.com/Bicentury/" title="Facebook" target="_blank">
											<img src={iconFooterFacebook} alt="Facebook" />
										</OutboundLink>
									</li>
									<li>
										<OutboundLink href="https://www.instagram.com/bicentury/" title="Instagram" target="_blank" >
											<img src={iconFooterInstagram} alt="Instagram" />
										</OutboundLink>
									</li>
									<li>
										<OutboundLink href="https://www.youtube.com/user/BicenturyMKT" title="YouTube" target="_blank" >
											<img src={iconFooterYoutube} alt="YouTube" />
										</OutboundLink>
									</li>
								</ul>
							</li>
						</ul>
					</div>
				</section>
			</footer>
		)
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.jsx